import { Observable } from "rxjs";
import { Inject, Injectable } from "@angular/core";
import { StoreStateService } from "../services";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, } from "@angular/common/http";

@Injectable()
export class SettingInterceptor implements HttpInterceptor {
  storeId: number | null = null;
  //#region Constructor

  constructor(
    private _storeState: StoreStateService,
  ) { }

  //#endregion

  //#region Methods

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const storeId = this._storeState.getStoreId();
    if (storeId !== null) {
      request = request.clone({
        setHeaders: {
          StoreId: `${storeId}`,
        },
      });
    }
    return next.handle(request);
  }

  //#endregion
}
